var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__inner"},[_c('div',{staticClass:"header__top"},[_vm._t("orderHeader"),_vm._t("newUser")],2),_vm._t("headerBottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }